import { Box, Grid, Typography } from "@mui/material"
import { SyntheticEvent, useEffect, useState } from "react"
import { useToast } from "../../Hooks/useToast"
import { useUser } from "../../Hooks/useUser"
import { useUpdateClientMutation } from "../../Redux/api/clientApi"
import { useUpdateTalentMutation } from "../../Redux/api/talentApi"
import { useAppSelector } from "../../Redux/store"
import { ProfileType } from "../../Types/General"
import { NotificationSetting } from "./Components/Notifications/NotificationSetting"
import { Talent } from "../../Types/Talent"
import { Client } from "../../Types/Client"

export const NotificationSettings = () => {
    /* ******************** Hooks ******************** */
    const { type, user } = useUser();
    const { showToast } = useToast();
    const [updateClient] = useUpdateClientMutation();
    const [updateTalent] = useUpdateTalentMutation();
    /* ******************** Variables ******************** */
    const isClient = type == ProfileType.Client;
    const [settings, setSettings] = useState<any>(user?.notifications)
    const notificationPrefereneces = [
        {id:'email', label: 'I want to receive email notifications', checked: settings?.email},
        {id:'text', label: 'I want to receive text message notifications', checked: settings?.text},
    ]
    /* ******************** Functions ******************** */
    const handleChecked = (params: SyntheticEvent) => {
        let newSettings = {...settings!}
        // @ts-ignore
        newSettings[params.target.id] = !settings[params.target.id]
        setSettings(newSettings);
        if (isClient) {
            updateClient({
                locator: user?.locator!,
                updated_data: {
                    notifications: {
                        email: newSettings.email,
                        text: newSettings.text,
                        //@ts-ignore
                        job: newSettings.job,
                        payment: newSettings.payment,
                        messages: newSettings.messages,
                        marketing: newSettings.marketing
                    }
                }
            })
            .unwrap()
            .catch((err) => {
                console.error("Error occured while updating settings: ", err);
                showToast({
                    text: "Unable to update settings",
                    variant: "error",
                });
                setSettings(settings);
            })
        }
        if (!isClient) {
            updateTalent({
                locator: user?.locator!,
                updated_data: {
                    notifications: {
                        email: newSettings.email,
                        text: newSettings.text,
                        payment: newSettings.payment,
                        messages: newSettings.messages,
                        marketing: newSettings.marketing,
                        //@ts-ignore
                        applicationAccepted: newSettings.applicationAccepted,
                        //@ts-ignore
                        applicationInvite: newSettings.applicationInvite
                    }
                }
            })
            .unwrap()
            .catch((err) => {
                console.error("Error occured while updating settings: ", err);
                showToast({
                    text: "Unable to update settings",
                    variant: "error",
                });
                setSettings(settings);
            })
        }
    }
    const getNotificationTypes = () => {
        let notificationTypes = [
            {id:'payment', label: 'Upcoming payment', checked: settings?.payment},
            {id:'messages', label: 'Messages', checked: settings?.messages}
        ] 
        //@ts-ignore
        if (isClient) notificationTypes.splice(0, 0, {id:'job', label: 'Job application', checked: settings?.job});
        if (!isClient) notificationTypes = ([
            //@ts-ignore
            {id:'applicationAccepted', label: 'Job application accepted', checked: settings?.applicationAccepted},
            //@ts-ignore
            {id:'applicationInvite', label: 'Job application invites', checked: settings?.applicationInvite},
        ]).concat(notificationTypes);

        return notificationTypes
    }
    /* ******************** Effects ******************** */
    useEffect(()=>{
        if (user?.notifications) {
            setSettings(user.notifications)
        } else {
            const defaultSettings = type == ProfileType.Client ? {
                email: false,
                text: false,
                messages: false,
                payment: false,
                marketing: false
            } : {
                email: false,
                text: false,
                messages: false,
                payment: false,
                marketing: false,
                applicationInvite: false,
                applicationAccepted: false
            }
            setSettings(defaultSettings);
        }
    }, [user])
    /* ******************** JSX ******************** */
    return (
        <Box
            paddingX={12}
            paddingTop={11}
        >
                <Typography variant="lora-headline-small">Notifications</Typography>
                <Grid display={"flex"} flexDirection={"column"}  marginTop={'28px'} marginBottom={1}>
                    <Typography variant="title-small">Notification preferences</Typography>
                </Grid>
                <Grid display={'flex'} flexDirection={'column'}>
                    {notificationPrefereneces.map( n => (
                        <NotificationSetting 
                            key={n.label} 
                            text={n.label} 
                            checked={n.checked} 
                            onChange={handleChecked} 
                            id={n.id}
                        />
                    ))}
                </Grid>
                <Grid display={"flex"} flexDirection={"column"}  marginTop={'60px'} marginBottom={1}>
                    <Typography variant="title-small">Notification Types</Typography>
                </Grid>
                <Grid display={'flex'} flexDirection={'column'}>
                    {getNotificationTypes().map( n => (
                        <NotificationSetting 
                            key={n.label} 
                            text={n.label} 
                            checked={n.checked} 
                            onChange={handleChecked} 
                            id={n.id}
                        />
                    ))}
                </Grid>
                <Grid display={"flex"} flexDirection={"column"}  marginTop={'60px'} marginBottom={1}>
                    <Typography variant="title-small">Other</Typography>
                </Grid>
                <Grid display={'flex'} flexDirection={'column'}>
                        <NotificationSetting 
                            text={'I want to receive promotional email communications'} 
                            checked={settings?.marketing} 
                            onChange={handleChecked} 
                            id={'marketing'}
                        />
                </Grid>
        </Box>
    )
}